export enum PAGENAME {
  PLP_PAGE = 's',
  SEARCH_START = 'searchStart',
}

export const MIN_SEARCH_KEYWORD_LENGTH = 2;
export const SEARCH_PRODUCT_LIMIT = 20;
export const PRODUCT_ID_PREFIX = 'gid://shopify/Product/';

export enum DeviceType {
  MOBILE = 'mobile',
  DESKTOP = 'desktop',
  TABLET = 'tablet',
  REACT_NATIVE = 'reactnative',
}
